import React from "react";
import Modal from "react-modal";
import { InstitucionesExoneran, PorcentajesExoneracion, SiNo, TiposDocumentoExoneracion } from "../Comunes/Listas";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        padding: '20px'
    }
};


const ExoneracionModal = ({ modalIsOpen, closeModal, Gestor, Modificar }) => {
    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false} className={'mymodalExoneracion'} style={customStyles}>
            <h5 style={{ backgroundColor: '#019688', color: 'black', margin: '0px', padding: '8px' }}>Exoneración</h5>
            <div style={{ marginLeft: '0px', marginTop: '5px', fontSize: '10px' }}>
                <div className="row">
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <label>¿Exonera la línea a agregar?</label>
                    </div>
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <select id="cboAplicaExonera" name="cboAplicaExonera" className="w-full border rounded p-1" onChange={Modificar} value={Gestor.cboAplicaExonera}>
                            {SiNo.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-25" style={{ padding: '0 10px' }}>
                        <label>Tipo:</label>
                    </div>
                    <div className="col-75" style={{ padding: '0 10px' }}>
                        <select id="cboTipoDocExoneracion" name="cboTipoDocExoneracion" className="w-full border rounded p-1" onChange={Modificar} value={Gestor.cboTipoDocExoneracion}>
                            {TiposDocumentoExoneracion.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <label>Número Documento:</label>
                    </div>
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <input name="txtNumeroDocumentoExonera" type="text" className="w-full border rounded p-1" id="txtNumeroDocumentoExonera" onChange={Modificar} value={Gestor.txtNumeroDocumentoExonera} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <label>Nombre Institución:</label>
                    </div>
                    <div className="col-50" style={{ padding: '0 10px' }}>

                        <select id="txtNombreInstiExonera" name="txtNombreInstiExonera" className="w-full border rounded p-1" onChange={Modificar} value={Gestor.txtNombreInstiExonera}>
                            {InstitucionesExoneran.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <label>Porcentaje Exoneración:</label>
                    </div>
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <select id="cboPorcentajeExoneracion" name="cboPorcentajeExoneracion" className="w-full border rounded p-1" onChange={Modificar} value={Gestor.cboPorcentajeExoneracion}>
                            {PorcentajesExoneracion.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <label>Fecha Emisión:</label>
                    </div>
                    <div className="col-50" style={{ padding: '0 10px' }}>
                        <input name="txtFechaEmisionExonera" type="date" className="w-full border rounded p-1" id="txtFechaEmisionExonera" onChange={Modificar} value={Gestor.txtFechaEmisionExonera} />
                    </div>
                </div>
                {Gestor.cboTipoDocExoneracion === '02' || Gestor.cboTipoDocExoneracion === '03' || Gestor.cboTipoDocExoneracion === '06' || Gestor.cboTipoDocExoneracion === '07' || Gestor.cboTipoDocExoneracion === '08' ? (<>
                    <div className="row">
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <label>Artículo:</label>
                        </div>
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <input name="Articulo" type="text" className="w-full border rounded p-1" id="Articulo" onChange={Modificar} value={Gestor.Articulo} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <label>Inciso:</label>
                        </div>
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <input name="Inciso" type="text" className="w-full border rounded p-1" id="Inciso" onChange={Modificar} value={Gestor.Inciso} />
                        </div>
                    </div>
                </>) : null}
                <br />
                <div className="row">
                    <div className="col-25">
                        <button style={{ width: '90%' }} onClick={closeModal}>Guardar</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ExoneracionModal;